{
  "version": 1,
  "asset_id": "de5873cc-4ef5-4bb9-932f-f1caa5ca3ff2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/de5873cc-4ef5-4bb9-932f-f1caa5ca3ff2/sleeve-ugi-reflux-post-1206-es.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/de5873cc-4ef5-4bb9-932f-f1caa5ca3ff2/sleeve-ugi-reflux-post-1206-es.webp",
  "original_filename": "sleeve-ugi-reflux-post-1206-es.webp",
  "size": 76118,
  "content_type": "image/webp",
  "created_at": "2026-09-28T16:44:15Z"
}
